<template>
    <div class="layout-container">
        <side-bar :collapse="isMobile" />
        <div class="main">
            <div class="view">
                <keep-alive>
                    <router-view />
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './SideBar';
import { isMobile } from '@/utils/mobile';

export default {
    data() {
        return { isMobile: false };
    },
    components: {
        SideBar,
    },
    mounted() {
        this.isMobile = isMobile();
    }
};
</script>

<style scoped>
.layout-container {
    display: flex;
    height: 100vh;
    width: 100vw;
}

.layout-sidebar {
    height: 100%;
}

.main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.view {
    overflow: auto;    
    height: 100%;
}
</style>
